export const ALLOWED_HISTORY_MESSAGES_AMOUNT = 6;

export const MISSING_MESSAGE = '<<missing>>';

export enum UnrelatedAction {
  EDITOR_ACTION = 'Editor Action',
  BRIEF_ACTION = 'Brief Action',
  IRRELEVANT = 'Irrelevant',
  DESCRIBE = 'Describe',
}

export enum ChatMessageRole {
  System = 'system',
  User = 'user',
  Assistant = 'assistant',
  SYSTEM = 'SYSTEM',
  USER = 'USER',
  ASSISTANT = 'ASSISTANT',
}

export enum ChatTopic {
  Theme = 'theme',
  Coloration = 'coloration',
  ThemeRecommendation = 'theme_recommendation',
  Layout = 'layout',
  ImageCollection = 'imageCollection',
  SiteProfile = 'siteProfile',
  Structure = 'structure',
  Media = 'media',
  Business = 'business',
  ColorPalette = 'colorPalette',
  Description = 'description',
  MatchImages = 'matchImages',
}

export enum InitialPromptActions {
  UNRELATED = 'Unrelated',
  DONE = 'Done',
  CHANGE_THEME = 'Change Theme',
  APPLY_THEME_VARIATION = 'Apply Theme Variation',
  APPLY_LAYOUT_VARIATION = 'Apply Layout Variation',
  SHUFFLE_COLORS = 'Shuffle Colors',
}

export enum PromptNames {
  THEME_RELATED = 'theme_related',
  LAYOUT_RELATED = 'layout_related',
}

export enum PromptHubAcceptedUrls {
  AI_GATEWAY_URL = '/_serverless/ai-gateway/prompt',
  AI_GATEWAY_URL_NEW = '/_serverless/ai-gateway/ai-prompt',
  AI_GATEWAY_OBJECT_URL_NEW = '/_serverless/ai-gateway/ai-object-prompt',
  AI_GATEWAY_GET_PROMPT_URL = '/_serverless/ai-gateway/get-prompt',
  AI_GATEWAY_GET_BLACK_FOREST_AI_IMAGE = '/_serverless/ai-gateway/black-forest-ai-image-object-prompt',
  AI_GATEWAY_GET_RUNWARE_AI_IMAGE = '/_serverless/ai-gateway/runware-ai-image-object-prompt',
  AI_GATEWAY_GET_REPLICATE_AI_IMAGE = '/_serverless/ai-gateway/replicate-ai-image-object-prompt',
  AI_GATEWAY_GET_PHOTOROOM_AI_REMOVE_BG = '/_serverless/ai-gateway/photoroom-ai-remove-bg',
}

export const AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS = `e36c4531-99b6-4a9a-b523-451cca8bf286`;

export const PROMPT_HUB_PROMPTS_ID = {
  MATCH_IMAGES_PROMPT: '882d9169-f834-4d5d-b22c-e7c4646a7232',
  THEME_PROMPT: '974fedec-5887-456b-8759-be294b6ab082',
  THEME_RECOMMENDATION_PROMPT: 'd4a7aeca-7e60-4220-ab20-659dc881fc97',
  LAYOUT_PROMPT: '74b9eee5-839f-44eb-b300-7845f603cd0b',
  THEME_RELATED: `20b8edea-817a-4755-b6b1-b9d3ece3bb4b`,
  THEME_RELATED_LOCALIZATION: '6ac7d573-adec-4633-9f3f-e94e092e51c1',
  THEME_UNRELATED: 'b8c1f090-b642-450a-b572-767b73d9d37c',
  LAYOUT_RELATED: `0a294829-cf72-4eb0-a9ce-ca6bcfe678ec`,
  LAYOUT_RELATED_LOCALIZATION: '5df7b02b-4af2-4438-86c1-318ae5737aaf',
  LAYOUT_UNRELATED: '7c123995-8592-40a6-9d3c-264af5307a58',
  USER_INPUT_TRANSLATOR: '807af37d-6e05-40b1-85f6-785496b91760',
};

export enum MatchImagesPromptResponseProperties {
  IMAGE_SET = 'Image Set',
}

export const emptyInitialUserMessage = {
  content: '',
  role: ChatMessageRole.User,
};

export const SITE_HISTORY_CACHE_SIZE = 5;
